import styled from 'styled-components';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';

export const StyledDrawer = styled(SwipeableDrawer)`
  .MuiDrawer-paper {
    background-color: var(--widget);
    box-shadow: var(--widget-shadow);
    padding: 30px;
    border: none;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    /* Disable MUI v7 Paper overlay/shadow CSS variables */
    --Paper-overlay: none;
    --Paper-shadow: none;
    background-image: none;

    .logo-wrapper {
      padding-bottom: 40px;
    }
  }
`;

export const StyledAccordion = styled(Accordion)`
  && {
    background-color: transparent;
    box-shadow: none;
    background-image: none;
  }

  /* Disable MUI v7 Paper overlay/shadow CSS variables */
  --Paper-overlay: none;
  --Paper-shadow: none;

  &:before {
    display: none;
  }

  &&.Mui-expanded {
    margin: 0;
  }
`;

export const StyledAccordionSummary = styled(AccordionSummary)`
  && {
    padding: 0 10px;
    min-height: unset;
    margin: 0 -10px;
    border-radius: 4px;
  }

  height: 40px;
  transition: background-color var(--transition);

  && .MuiAccordionSummary-content {
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .icon-chevron-down {
    will-change: transform;
    transition: all var(--transition);
    color: var(--text);
    font-size: 0.625rem;
  }

  &.Mui-expanded, &.active {
    background: var(--border);

    .icon-chevron-down {
      transform: rotate(180deg);
      color: var(--header);
    }
  }
`;

export const StyledAccordionDetails = styled(AccordionDetails)`
  && {
    padding: 20px 10px 10px;
  }

  display: flex;
  flex-direction: column;
  gap: 10px;

  a {
    color: var(--text);
    transition: all var(--transition);
    width: fit-content;
    font-family: var(--heading-font);
    font-weight: 600;
    font-size: 13px;

    &:hover, &:focus,
    &.active {
      color: var(--highlight);
    }
  }
`;

export const SingleLink = styled(StyledAccordionSummary)`
  display: flex;
  align-items: center;

  a {
    display: flex;
    align-items: center;
    flex: 1;
    color: inherit;
    text-decoration: none;
  }

  &&.pinned {
    margin-top: 15px;
  }
`;

export const Link = styled.span`
  color: var(--header);
  display: inline-flex;
  align-items: center;
  gap: 12px;
  font-family: var(--heading-font);
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.3px;
  transition: color var(--transition);
  height: fit-content;

  &:hover, &:focus,
  &.active {
    color: var(--highlight);
  }

  .icon {
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
  }
`;
